// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_gA","advertCardList_max6":"c-a_gB"};